import React, { useCallback } from 'react';
import { GenericInputModal } from '@ydistri/ds';
import { useCreateAsoScenarioMutation } from '../apiAso';
import { useNavigate } from 'react-router';
import { useStableParams } from '../../../routes/useStableParams';
import { generatePartialPath } from '../../../routes/routerSlice';
import { ROUTES } from '../../../components/menu/getMenuLeftItems';

interface CreateAsoScenarioModalProps {
  open: boolean;
  asoRequestId?: number;
  onCancel: () => void;
}

const CreateAsoScenarioModal: React.FC<CreateAsoScenarioModalProps> = ({
  open,
  asoRequestId,
  onCancel,
}) => {
  const [createAso, { isLoading: confirmLoading }] = useCreateAsoScenarioMutation();
  const navigate = useNavigate();
  const { projectShortName } = useStableParams();

  const handleConfirm = useCallback(
    (name: string) => {
      if (!asoRequestId) return;

      createAso({ name, asoRequestId }).then(response => {
        if ('data' in response && response.data?.id) {
          const params: Record<string, string | undefined> = {
            projectShortName: projectShortName ?? undefined,
            asoRequestId: String(asoRequestId),
            asoScenarioId: String(response.data.id),
          };

          const path = generatePartialPath(ROUTES.asoChildRoute, params, undefined);
          navigate(path);
        }

        onCancel();
      });
    },
    [asoRequestId, createAso, navigate, onCancel, projectShortName],
  );

  if (!open) return null;

  return (
    <GenericInputModal
      title="Create ASO"
      placeholder="Name"
      onConfirmed={handleConfirm}
      onClose={onCancel}
      submitButtonLabel="Create"
      requiredMessage="Please enter a name for your ASO"
      confirmLoading={confirmLoading}
      submitDisabled={!asoRequestId}
    />
  );
};

export default CreateAsoScenarioModal;
